const local = {
  //apiUrl: 'https://api-dasa.smi-mexico.com/',
  apiUrl: 'https://localhost:44325/',
};


const preprod = {
  apiUrl: 'https://api-dasa.smi-mexico.com/',
 //septiembre25: https://jhufg7pjn1.execute-api.us-west-2.amazonaws.com/Prod
};

const apiWebService = {
  //AddressMicroService: 'http://localhost:50100',               //Local
  smiMicroService: 'https://webservice.smi-mexico.com', //+ '/Prod',            //Server
  WebSocketUrl: 'wss://i6ajfdflob.execute-api.us-west-2.amazonaws.com/production',
  googleApiKey: 'AIzaSyCK6EaX8lR_Bp5GpYWYd1709IxVdDmqKGs',
};

const distribution =
  process.env.REACT_APP_STAGE === 'preprod'
    ? preprod
    : local;

const config = {
  ...distribution,
  validFileTypes: ['jpg', 'png', 'gif', 'jpeg', 'bmp', 'svg'],
  AddressMicroService: apiWebService.smiMicroService + '/api/direcciones/',    //Server CADE AWS:server2025@smi-mexico.com
  WebSocketUrl: apiWebService.WebSocketUrl,        //Lambda notificaciones
  SatMicroService: apiWebService.smiMicroService + '/api/sat/',    //Server CADE AWS:server2025@smi-mexico.com
  googleApiKey: apiWebService.googleApiKey,     //
  reportingService: 'https://soporteinteryoga.jsreportonline.net/',
}; 

export const reportCredentials =
  'c29wb3J0ZXdlYkBpbnRlcnlvZ2EuY29tLm14OjNTeU0lNTJhfStfLw==';

export default config;
